import * as Yup from "yup";

export const priceRangeValidationSchema = Yup.object({
  ItemQty: Yup.number()
    .required("Item Quantity is required")
    .positive("Item Quantity must be greater than 0")
    .integer("Item Quantity must be an integer"),
  ItemPercentage: Yup.number()
    .required("Item Percentage is required")
    .min(0, "Percentage cannot be negative")
    .max(100, "Percentage cannot exceed 100"),
  IsActive: Yup.boolean().required("Status is required"),
});
